global.errorCode = {
    "EA_DAA_SI_01": "信息缺失，请补全信息重新提交",
    "EA_DAA_SI_02": "验证码错误，请输入正确验证码",
    "EA_DAA_SI_03": "密码错误超过5次，请10分钟后再试",
    "EA_DAA_SI_04": "您输入的帐号不存在，请输入正确账号",
    "EA_DAA_SI_05": "密码错误，请重新输入",
    "EA_MAA_CDC_01": "信息缺失，请补全信息重新提交",
    "EA_MAA_CDC_02": "验证码错误，请输入正确验证码",
    "EA_MMA_GSLDCTS_01": "信息缺失，请补全信息重新提交",
    "EA_MAA_SI_01": "信息缺失，请补全信息重新提交",
    "EA_MAA_SI_02": "手机验证码错误，请输入正确验证码",
    "EA_MAA_SUAI_01": "信息缺失，请补全信息重新提交",
    "EA_MAA_SUAI_02": "手机验证码错误，请输入正确验证码",
    "EA_MAA_SUAI_03": "该手机号已被注册，可使用手机验证码登录",
    "EA_EAA_CDC_01": "信息缺失，请补全信息重新提交",
    "EA_EAA_CDC_02": "验证码错误，请输入正确验证码",
    "EA_EAA_SUAI_01": "信息缺失，请补全信息重新提交",
    "EA_EAA_SUAI_02": "邮箱验证码错误，请输入正确验证码",
    "EA_EAA_SUAI_03": "该邮箱已被注册",
    "EA_ASA_CDC_01": "信息缺失，请补全信息重新提交",
    "EA_ASA_CDC_02": "验证码错误，请输入正确验证码",
    "EA_ASA_CDC_03": "您输入的手机号（邮箱）不存在，请重新输入",
    "EA_ASA_RP_01": "信息缺失，请补全信息重新提交",
    "EA_ASA_RP_02": "验证码错误，请输入正确验证码",
    "EA_ASA_RP_03": "您输入的手机号（邮箱）不存在，请重新输入",
    "EA_NACIA_BU_01": "信息缺失，请补全信息重新提交",
    "EA_NACIA_BU_02": "账号错误，请输入6-26数字或字母",
    "EA_NACIA_BU_03": "账号信息缺失，请联系客服解决",
    "EA_NACIA_BU_04": "",
    "EA_NACIA_BU_05": "该账号已被占用，请重新输入",
    "EA_NACIA_BU_06": "密码验证错误，请输入正确密码",
    "EA_NACIA_BU_07": "身份信息错误，请输入正确信息",
    "EA_NACIA_BU_08": "绑定失败，该账号已绑定其它手机号",
    "EA_NACIA_CI_01": "信息缺失，请补全信息重新提交",
    "EA_NACIA_CI_02": "该账号已被占用，请重新输入",
    "EA_NACIA_CI_03": "该证件已被注册",
    "EA_NACIA_CI_04": "账号已被完善，请直接登录",
    "EA_NACIA_CI_05": "账号错误，请输入6-26数字或字母",
    "EA_NACIA_CI_06": "身份证不符合规则",
    "OSS_O_GTDL_01": "信息缺失，请补全信息重新提交",
    "PC_OPIA_GCII_01": "信息缺失，请补全信息重新提交",
    "PC_OPIA_CIAL_01": "信息缺失，请补全信息重新提交",
    "PC_OPIA_CIAL_02": "照片中没有人脸请重新上传",
    "PC_OPIA_CIAL_03": "登录超时，请重新登录",
    "PC_OPIA_CIAL_04": "系统错误，请重新上传照片",
    "PC_OPIA_GPI_01": "登录超时，请重新登录",
    "PC_OPIA_UPI_01": "信息缺失，请补全信息重新提交",
    "PC_OPIA_UPI_02": "登录超时，请重新登录",
    "PC_OPIA_UPI_03": "该证件已被注册",
    "NACIA_SDCFOCI_01": "信息缺失，请补全信息重新提交",
    "ASA_VDCFOCI_01": "信息缺失，请补全信息重新提交",
    "ASA_VDCFOCI_02": "验证码错误，请输入正确验证码",
    "ASA_RP_01": "密码要求6-26位数字、字母、特殊字符",
    "ASA_RP_03": "安全验证错误，请输入正确验证信息",
    "ASA_VDCWMI_01": "信息缺失，请补全信息重新提交",
    "ASA_VDCWMI_02": "验证码错误，请输入正确验证码",
    "ASA_VDCWMI_03": "传入的手机号或邮箱号和当前用户所持有的手机号对不上",
    "ASA_SDCFSA_01": "信息缺失，请补全信息重新提交",
    "ASA_SDCFMAB_01": "信息缺失，请补全信息重新提交",
    "ASA_MEB_01": "信息缺失，请补全信息重新提交",
    "ASA_MEB_02": "该邮箱已被绑定",
    "ASA_MEB_03": "登录超时，请重新登录",
    "ASA_MEB_04": "验证码错误，请输入正确验证码",
    "ASA_MEB_05": "安全验证错误，请输入正确验证信息",
    "ASA_MMB_01": "信息缺失，请补全信息重新提交",
    "ASA_MMB_02": "该手机号已被绑定",
    "ASA_MMB_03": "登录超时，请重新登录",
    "ASA_MMB_04": "验证码错误，请输入正确验证码",
    "ASA_MMB_05": "安全验证错误，请输入正确验证信息",
    "ASA_VPWMI_01": "信息缺失，请补全信息重新提交",
    "ASA_VPWMI_02": "当前用户信息不存在默认账号，属非法操作",
    "ASA_VPWMI_03": "密码错误，请重新输入",
    "E_REG_ERIVOQC_01": "报考信息错误，请重新报考",
    "E_REG_ERIVOQC_02": "暂无操作权限，请确认后再试",
    "ERRG_SRSSCV_01": "系统错误，请重新报考",
    "ERRG_SRSSCV_02": "系统错误，请重新报考",
    "ERRG_SRSSCV_03": "系统错误，请重新报考",
    "ERRG_SRSSCV_04": "系统错误，请重新报考",
    "ERG_SRSSH_01": "考试已暂停，请查看公告，以便了解最新通知",
    "ERG_ER_UERSS_01": "您无操作权限，请确认后再试",
    "ERRG_CNERCV_01": "系统错误，请重新报考",
    "ERRG_CNERCV_02": "系统错误，请重新报考",
    "ERG_CNERH_01": "考试已暂停，请查看公告，以便了解最新通知",
    "ERRG_SERACV_01": "系统错误，请重新报考",
    "ERRG_SERACV_02": "系统错误，请重新报考",
    "ERG_SERAH_01": "考试已暂停，请查看公告，以便了解最新通知",
    "ERI_RT_SA_01": "您无操作权限，请确认后再试",
    "ERI_RT_SA_02": "请完善信息",
    "ERG_CERAH_01": "考试已暂停，请查看公告，以便了解最新通知",
    "ERRG_SUITECV_01": "系统错误，请重新报考",
    "ERRG_SUITECV_02": "系统错误，请重新报考",
    "ERRG_SUITECV_03": "提交文件信息错误，请确认后再试",
    "ERRG_SUITECV_04": "请完善信息",
    "ERRG_SUITECV_05": "身份证号码格式错误，请填写正确身份证号码",
    "ERRG_SUITECV_06": "手机格式验证不正确，请填写正确信息",
    "ERRG_SUITECV_07": "邮箱格式验证不正确，请填写正确信息",
    "ERG_SUIEH_01": "考试已暂停，请查看公告，以便了解最新通知",
    "ERG_ER_SITE_01": "您无操作权限，请确认后再试",
    "ERG_RSSA_GER_01": "系统错误，请重新再试",
    "ERG_RSSA_GER_02": "考试已暂停，请查看公告，以便了解最新通知",
    "ERG_RSSA_GSBR_01": "系统错误，请重新再试",
    "ERG_RSSA_GSBR_02": "考区已被删除，请重新选择",
    "ERG_RSSA_GSBR_03": "请查看公告，以便了解最新通知",
    "ERG_RSSA_GSBR_04": "考区选择错误，请重新选择",
    "EAM_EXM_CT_GECV_02": "您无操作权限，请确认后再试",
    "ES_SC_GET_02": "没有批次信息",
    "SWITCH_OFF$MS_ES_R": "报考暂未开放，请关注报考通知，以便及时了解最新报考开放时间",
    "SWITCH_OFF$MS_EM_R": "已开始项目不可进行任何编辑操作，请暂停项目再进行编辑",
    "SWITCH_OFF$MS_EM_A": "考生审核暂未开放，请耐心等候",
    "SWITCH_OFF$MS_ES_ERQ": "成绩查询暂未开放，请耐心等候",
    "SWITCH_OFF$MS_ES_AP": "准考证打印暂未开放，请关注报考通知，以便及时了解准考证打印开放时间",
    "SWITCH_OFF$MS_ES_P": "考生支付暂未开放，请耐心等候",
    "EAM_EXM_CT_GBPI_01": "没有批次信息",
    "E_REG_GBPI_02": "没有批次信息",
    "EXM_R_PRSH_01": "报考信息错误，请确认后重新操作",
    "EXM_R_PRSH_02": "科目总价小于等于0，无需支付",
    "EXM_R_PRSH_03": "支付暂停，请开放后完成支付",
    "EXM_R_PRSH_04": "该报考已支付成功",
    "EXM_R_PRSH_05": "该考试不需要付费，请重新报考",
    "ERG_RSSA_PVOQ_01": "报考信息不存在	",
    "ERG_RSSA_PVOQ_02": "您无操作权限，请确认后再试",
    "ERG_RSSA_PVOQ_03": "支付尚未开通，请联系客服解决",
    "PI_PL_AUTR_01": "信息填写错误，请重填信息重新提交",
    "PI_PL_AUTR_02": "当前无此用户",
    "RG_SUB_LMT_RCH": "抱歉，您报考科目名额已满，报名系统会根据考生支付情况释放未支付考生名额",
    "E_REG_SUI_PAYED": "已支付无法修改信息",
    "E_REG_SUS_PAYED": "已支付无法修改信息",
    "E_REG_SUI_GU_NA": "抱歉，集体账号暂无权限为当前考生报名，考生已迁入其它集体账号",
    "E_REG_SUI_AUDITED": "当前报考记录已经审核通过，不可修改报考信息",
    "ERG_SERAH_02": "当前有考生报考任务进行中，稍后重试",
    "ERG_SERAH_03": "当前集体已经达到限报名额",
    "E_REG_SUS_SAME_SUB_SELECTED": "该考生已经成功报考此科目，不允许重复报考同一科目",
    "ERRG_PRSV_01": "报考信息错误，请确认后重新操作",
    "ERRG_PRSV_02": "请补全发票信息",
    "E_REG_SUI_RULE_FAILED": "抱歉，报考资格不符，请查阅报考资格说明",
    "E_REG_SUI_IN_O_GS": "该考生已在其他集体下，无法挂靠当前选中集体",
    "ER_GSH_01": "抱歉，您并没有报考该考试，暂无预约权限",
    "E_REG_C_FRP_01": "网络繁忙，请刷新后重新上传",
    "E_REG_C_FRP_02": "网络繁忙，请刷新后重新上传",
    "E_REG_C_FRP_03": "人脸识别异常，请联系客服",
    "E_REG_C_FRP_04": "请上传带有清晰正面的免冠照！",
    "ER_GRID_01": "暂无报考信息，无法预约",
    "ER_CS_01": "您已打印准考证，不可取消预约",
    "E_REG_GELC_01": "考试批次不存在，请重新选择",
    "E_REG_GELC_02": "用户ID错误，请重新操作",
    "E_REG_GEL_01": "考试批次不存在，请重新选择",
    "E_REG_GEL_02": "考试批次不存在，请重新选择",
    "SWITCH_OFF$MS_ES_APM": "考试预约暂未开放，请关注考试通知，以便及时了解考试预约开放时间",
    "EA_GUTNI_01": "系统繁忙，请刷新后重新操作",
    "EA_GUTNI_02": "系统繁忙，请刷新后重新操作",
    "EM_CGNA_GUN_01": "系统繁忙，请刷新后重新操作",
    "EA_NACIA_CI_07": "证件号，姓名与系统存储中的信息不一致,请检查填写是否正确",
    "EAM_EXM_CT_ECQA_BEC_01": "考试项目或用户权限错误，请确认后重新操作",
    "EAM_EXM_CT_ECQA_BEC_02": "获取准考证模板失败，请刷新后重新操作",
    "E_REG_SUI_GU_FT": "抱歉，您的出生年月不符合报考要求",
    "SWITCH_OFF$MS_ES_ER": "免试暂未开放，请关注免试通知，以便及时了解最新免试开放时间",
    "ERRG_PRSV_03": "邮箱输入不正确，请修改",
    "ERG_RSSA_QFSA_01": "系统错误，请重新再试",
    "ERG_RSSA_QFSA_02": "报考信息错误，请确认后重新操作",
    "ERG_RSSA_QFSA_03": "报考信息缺失，请补全报考信息后重新操作",
    "EXM_REG_SA_01": "系统错误，请重新报考",
    "EXM_REG_SA_02": "系统错误，请重新报考",
    "EXM_REG_SA_03": "系统错误，请重新报考",
    "EXM_REG_SA_04": "报考资格不符合要求，请确认后重新操作",
    "EXM_REG_SA_05": "报考科目冲突，请确认后重新操作",
    "EXM_R_PMTR_01": "网络繁忙，请刷新后再试",
    "EXM_R_PMTR_02": "更换考区开关未开启，请确认后重试",
    "EXM_R_PMTR_03": "该考区未开放此报考科目，请重新选择",
    "E_REG_GRD_OR_01": "系统错误，请重新再试",
    "E_REG_GRD_OR_02": "系统错误，请重新再试",
    "E_REG_GRD_OR_03": "传递参数不正确",
    "E_REG_GRD_OR_04": "考生报考信息错误，请确认后重新操作",
    "E_REG_URD_OR_01": "系统错误，请重新报考",
    "E_REG_URD_OR_02": "系统错误，请重新报考",
    "E_REG_URD_OR_03": "系统错误，请重新报考",
    "E_REG_URD_OR_04": "报考信息错误，请刷新后重新操作",
    "E_REG_URD_OR_05": "订单信息错误，请确认是否为集体缴费或支付失败状态",
    "E_REG_URD_OR_06": "报考信息错误，请刷新后重新操作",
    "E_REG_URD_OR_07": "请勾选科目后提交",
    "E_REG_URD_OR_08": "科目信息错误，请确认后重新操作",
    "ER_GSH_02": "您在1分钟内已经发起过预约，请勿重复发起",
    "E_REG_URD_OR_09": "支付完成后才可申请退款",
    "SWITCH_OFF$MS_RCS_R": "考区变更暂未开放",
    "SWITCH_OFF$MS_SAC_R": "科目增加暂未开放",
    "SWITCH_OFF$MS_RAS_R": "考生退款申请暂未开放",
    "E_REG_CET_NA": "证件类型匹配失败，请确认证件类型是否符合报考要求",
    "EXM_CV_ECQA_BEC_01": "考试项目或用户权限错误，请确认后重新操作",
    "EXM_CV_ECQA_BEC_02": "获取个人简历模板失败，请刷新后重新操作",
    "EXAM_REG_UII_V01": "纳税人识别号错误",
    "EXAM_REG_UII_01": "打开发票修改开关",
    "EXAM_REG_UII_02": "无需要修改信息的订单",
    "EXAM_REG_UII_03": "配置发票配置信息",
    "EXAM_REG_UII_04": "开票成功的订单不允许修改信息",
    "EXM_REG_CISMMR_01": "科目不可同时报考，请确认报考规则后重新选择",
    "EXM_REG_CSRIMRR_01": "报考规则不符，请确认报考规则后重新操作",
    "EXM_REG_ABI_01": "当前暂无可开票数据，请确认后再操作",
    "EXM_REG_ABI_02": "当前发票已开票成功或申请开票中,不允许重复开票",
    "EXM_REG_ABI_03": "开票申请已关闭",
    "EXM_REG_ABI_04": "配置发票配置信息",
    "EXM_REG_ABI_05": "开票申请失败，请刷新后重新操作",
    "EXM_REG_ABI_06": "开票失败，请重新申请开票",
    "EXM_REG_ABI_07": "开票申请签名错误",
    "EXM_REG_ABI_08": "开票数据错误，请确认后重新操作",
    "EXM_CT_ECQA_BEC_01": "未获取到准考证信息，请刷新后重新操作",
    "EXM_CT_ECQA_BEC_02": "未配置准考证模板，请配置准考证模板",
    "EXM_CT_ECQA_BEC_03": "考试项目或用户权限错误，请确认后重新操作",
    "candidate_seat_apply failed": "当前预约人数过多，请稍后再试",
    "EXM_REG_ABI_REPEAT_SUBMIT": "发票申请已提交,请勿重复申请",
    "E_REG_SUI_SSRS_04": "请选择正确科目数量进行报考",
    "EXM_REG_CISMMR_02": "请选择正确科目数量进行报考",
    "EXM_REG_CNERC_02": "您已报考其它省份，请勿重复报考",
    "ERG_SERAH_04": "您已报考其它省份，请勿重复报考",
    "EPC_ASA_UCA_03": "证件号码规则不符，请输入正确证件号码",
    "SWITCH_OFF$MS_ARP_R": "报考功能暂未开放",
    "EXM_CT_ECQA_BEC_C1": "准考证模板尚未准备好，请耐心等待",
    "EXM_CT_ECQA_BEC_C2": "准考证模板未获取到动态填充模板内容，请耐心等待",
    "EXM_CT_ECQA_BEC_C3": "多科一证模板配置信息有误",
    "EXM_R_PRSH_07": "发票未配置相关信息，请向工作人员反馈",
    "EXM_R_PRSH_06": "发票收集暂停，请开放后继续采集发票信息",

    //certificate
    "CRI_GCA_GCL_01": "未查询到考生证书申请信息",
    "CRA_Q_01": "未查询到考生用户信息",
    "CRA_Q_02": "未查询到考生用户信息",
    "CRA_Q_03": "未查询到考生证件类型信息",
    "SWITCH_OFF": "当前不处于证书申请时间范围，请查询具体时间后申请",
    "CRA_SCI_01": "证件类型配置错误",
    "CRA_SCI_02": "时间类型格式错误",
    "CRA_SCI_03": "系统错误，请重新申请",
    "CRA_SCI_04": "系统错误，请重新申请",
    "CII_GCA_GCL_01": "未查询到考生申请信息",
    "CII_GCA_GCL_02": "项目信息匹配错误，请刷新后重新操作",
    "CII_GCA_GCL_03": "项目信息匹配错误，请刷新后重新操作",
    "CIA_Q_01": "未查询到考生用户信息",
    "CIA_Q_02": "未查询到考生用户信息",
    "CIA_Q_03": "未查询到考生证件类型信息",
    "SWITCH_OFF": "证书申请不在时间范围内，请查询后再申请",
    "CRI_SII_AUDITED": "考生状态处于待审核状态，请审核通过后再提交",
    "SWITCH_OFF$MS_CAS_P": "证书申请已开始，不可进行任何编辑操作，请关闭申请后进行操作",
    "SWITCH_OFF$MS_CIS": "证书申领暂未开放，请关注申领通知，以便及时了解最新申领开放时间",
    "SWITCH_OFF$MS_CIS_P": "证书申领已开始，不可进行任何编辑操作，请关闭申领后进行操作",
    "SWITCH_OFF$MS_CCAS": "	证书申请审核已关闭",
    "SWITCH_OFF$MS_CPS": "证书查询暂未开放，请关注证书查询通知，以便及时了解最新查询开放时间",
    "SWITCH_OFF$MS_CAS": "证书申请暂未开放，请关注申请通知，以便及时了解最新申请开放时间",
    "EXM_REG_ARI_01": "红冲开关未开启",
    "EXM_REG_ARI_02": "开票信息错误，请刷新后重新操作",
    "EXM_REG_ARI_03": "开票信息错误，请刷新后重新操作",
    "EXM_REG_ARI_04": "发票正在红冲，请勿重复操作",
    "EXM_REG_ARI_05": "发票配置错误，请刷新后重新操作",
    "EXM_REG_ARI_06": "红冲发票信息返回错误，请刷新后重新操作",
    "EXM_REG_ARI_07": "红冲发票订单信息错误，请刷新后重新操作",
    "EXM_REG_ARI_08": "电子发票已红冲，请勿重复操作",
    "ERIA_UEI_01": "网络繁忙，请刷新后重新操作",
    "ERIA_UEI_02": "信息修改开关已关闭",
    "ERIA_UEI_03": "账号无权限操作此功能",
    "ERIA_UEI_04": "用户信息获取失败，请刷新后重新操作",
    "ERIA_UEI_05": "基本信息错误，请刷新后重新操作",
    "ERIA_UEI_06": "基本信息不符合当前科目报考规则",
    "ERIA_UEI_07": "基本信息不符合当前科目报考规则",
    "ERIA_UEI_08": "出生年月规则错误，请重新操作",
    "ERIA_UEI_09": "账号无权限操作此功能",
    "ERIA_UEI_10": "基本信息错误，请刷新后重新操作",

    "EXM_R_UC_03": "优惠券功能未开启",
    "EXM_R_UC_04": "请输入有效的优惠券码",
    "EXM_R_UC_01": "请输入有效的优惠券码",
    "EXM_R_UC_02": "使用优惠券失败，请重试",
    "EXM_R_CUP_01": "每个科目只能使用一张优惠券",
    "EXM_R_CUP_02": "您未报考该优惠券可用科目，请输入正确优惠券信息",
    "EXM_R_CCP_01": "优惠券已被使用，不可编辑",
    "CERT_G_FRS_01":"网络繁忙，请刷新后重新操作",
    "CERT_G_FRS_02":"网络繁忙，请刷新后重新操作",
    "CERT_G_FRS_03":"网络繁忙，请刷新后重新操作",
    "CERT_C_FRP_01":"网络繁忙，请刷新后重新上传",
    "CERT_C_FRP_02":"网络繁忙，请刷新后重新上传",
    "CERT_C_FRP_03":"网络繁忙，请刷新后重新上传",
    "CERT_C_FRP_04":"网络繁忙，请刷新后重新上传",
    "CERT_C_FRP_05":"人脸识别异常，请联系客服",
    "CERT_C_FRP_06":"请上传带有清晰正面的免冠照！",
    "ERRG_SUITECV_08":"当前用户信息提交异常|当前用户信息提交异常，请重新登录提交",
    "CERT_SUITECV_01":"系统错误，请重新报考",
    "CERT_SUITECV_02":"系统错误，请重新报考",
    "CERT_SUITECV_03":"提交文件信息错误，请确认后再试",
    "CERT_SUITECV_05":"身份证号码格式验证不正确，请填写正确信息",
    "CERT_SUITECV_06":"手机格式验证不正确，请填写正确信息",
    "CERT_SUITECV_07":"邮箱格式验证不正确，请填写正确信息",
    "CERT_SUITECV_08":"当前用户信息提交异常，请重新登录提交",
    "EXEM_SUITECV_05":"身份证号码格式验证不正确，请填写正确信息",
    "EXEM_SUITECV_06":"手机格式验证不正确，请填写正确信息",
    "EXEM_SUITECV_07":"邮箱格式验证不正确，请填写正确信息",
    "CERT_SUITECV_05":"身份证号码格式验证不正确，请填写正确信息"
}

global.getErrorMessage = function (code) {
    if (errorCode[code] != undefined) {
        return errorCode[code];
    } else {
        return code;
    }
}